"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Upload } from "lucide-react";

interface UploadZoneProps {
  getRootProps: () => any;
  getInputProps: () => any;
  isDragActive: boolean;
}

/**
 * Upload zone component for CSV file dropzone
 */
export function UploadZone({ getRootProps, getInputProps, isDragActive }: UploadZoneProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Upload CSV File</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          {...getRootProps()}
          className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors ${
            isDragActive ? "border-primary bg-primary/5" : "border-gray-300 dark:border-gray-700 hover:border-primary"
          }`}
        >
          <input {...getInputProps()} />
          <Upload className="h-12 w-12 mx-auto mb-4 text-gray-400" />
          {isDragActive ? (
            <p className="text-primary">Drop the CSV file here...</p>
          ) : (
            <div>
              <p className="text-lg font-medium">Drop your CSV file here</p>
              <p className="text-sm text-gray-500">or click to browse</p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
